import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-16 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-2">
        {/* Who this is for */}
        <div className="glass-card border-gold-900/30 p-8 md:p-10 rounded-2xl shadow-[0_10px_40px_rgba(201,168,76,0.05)]" data-id="element-3">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 font-serif flex items-center gap-4" data-id="element-4">
            <span className="w-10 h-10 rounded-full bg-gold-900/30 border border-gold-500/30 flex items-center justify-center shadow-inner" data-id="element-5">
              <CheckIcon className="w-5 h-5 text-gold-400" data-id="element-6" />
            </span>
            Who this is for
          </h2>

          <ul className="space-y-5" data-id="element-7">
            <li className="flex items-start gap-5" data-id="element-8">
              <div className="mt-1 bg-gold-950/50 rounded-full p-1 border border-gold-800/50" data-id="element-9">
                <CheckIcon className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-10" />
              </div>
              <p className="text-zinc-300 leading-relaxed text-lg" data-id="element-11">
                <strong className="text-white block mb-1 text-xl" data-id="element-12">
                  Concerned patriots
                </strong>
                Who fear the country they love will be unrecognizable in less
                than two years.
              </p>
            </li>
            <li className="flex items-start gap-5" data-id="element-13">
              <div className="mt-1 bg-gold-950/50 rounded-full p-1 border border-gold-800/50" data-id="element-14">
                <CheckIcon className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-15" />
              </div>
              <p className="text-zinc-300 leading-relaxed text-lg" data-id="element-16">
                <strong className="text-white block mb-1 text-xl" data-id="element-17">
                  Parents
                </strong>
                Who want to protect their children's minds from institutional
                indoctrination.
              </p>
            </li>
            <li className="flex items-start gap-5" data-id="element-18">
              <div className="mt-1 bg-gold-950/50 rounded-full p-1 border border-gold-800/50" data-id="element-19">
                <CheckIcon className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-20" />
              </div>
              <p className="text-zinc-300 leading-relaxed text-lg" data-id="element-21">
                <strong className="text-white block mb-1 text-xl" data-id="element-22">
                  Community leaders
                </strong>
                Who need tools to strengthen the spirit of their people.
              </p>
            </li>
            <li className="flex items-start gap-5" data-id="element-23">
              <div className="mt-1 bg-gold-950/50 rounded-full p-1 border border-gold-800/50" data-id="element-24">
                <CheckIcon className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-25" />
              </div>
              <p className="text-zinc-300 leading-relaxed text-lg" data-id="element-26">
                <strong className="text-white block mb-1 text-xl" data-id="element-27">
                  Defenders of truth
                </strong>
                Anyone who believes that freedom of speech is the right upon
                which all other rights rest.
              </p>
            </li>
          </ul>
        </div>

        {/* Who this is not for */}
        <div className="bg-zinc-900/20 border border-zinc-800/50 p-8 md:p-10 rounded-2xl" data-id="element-28">
          <h2 className="text-2xl md:text-3xl font-bold text-zinc-500 mb-6 font-serif flex items-center gap-4" data-id="element-29">
            <span className="w-10 h-10 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center" data-id="element-30">
              <XIcon className="w-5 h-5 text-zinc-600" data-id="element-31" />
            </span>
            Who this is NOT for
          </h2>

          <ul className="space-y-5" data-id="element-32">
            <li className="flex items-start gap-5 opacity-70" data-id="element-33">
              <XIcon className="w-6 h-6 text-zinc-600 flex-shrink-0 mt-1" data-id="element-34" />
              <p className="text-zinc-400 leading-relaxed text-lg" data-id="element-35">
                People who prefer the "peace" of slavery over the discomfort of
                freedom.
              </p>
            </li>
            <li className="flex items-start gap-5 opacity-70" data-id="element-36">
              <XIcon className="w-6 h-6 text-zinc-600 flex-shrink-0 mt-1" data-id="element-37" />
              <p className="text-zinc-400 leading-relaxed text-lg" data-id="element-38">
                Those who believe that cancellation and censorship are
                legitimate tools of social justice.
              </p>
            </li>
            <li className="flex items-start gap-5 opacity-70" data-id="element-39">
              <XIcon className="w-6 h-6 text-zinc-600 flex-shrink-0 mt-1" data-id="element-40" />
              <p className="text-zinc-400 leading-relaxed text-lg" data-id="element-41">
                People who wait for a politician to come save them without
                making any personal effort or sacrifice.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}